<template>
    <div class="main-page">
        <!--        <div class="navbar navbar-expand-md bsnav bsnav-transparent bsnav-brand-center bsnav-scrollspy bsnav-sticky bsnav-sticky-slide">-->
        <div class="navbar navbar-expand-md bsnav bsnav-transparent bsnav-brand-center bsnav-scrollspy  bsnav-sticky-slide sticked in sticked_navbar">
            <b-dropdown right class="lang_mob">
                <template slot="button-content">
                    <div class="lang_icon"></div>
                    <b class="lang_suffix">{{selectedLocale.suffix.toUpperCase()}}</b>
                </template>
                <b-dropdown-item v-for="language in languages" :key="language.name" @click="changeLanguage(language)">{{
                    language.name }}
                </b-dropdown-item>
            </b-dropdown>
            <router-link to="/" class="navbar-brand">
                <img class="brand-img bsnav-brand-center responsive" data-aos="fade-down"
                     data-aos-duration="1500" src="/static/images/logoDark.svg" alt="">
            </router-link>
            <button :class="(!mobile_open) ? 'navbar-toggler toggler-spring' : 'navbar-toggler toggler-spring active'"  @click="mobile_open = !mobile_open"><span class="navbar-toggler-icon"></span></button>
            <div class="collapse navbar-collapse justify-content-md-between">
                <ul class="navbar-nav navbar-mobile nav-desk">
                    <li class="nav-item">
                        <router-link to="/about-part" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.about_management')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/#objectspart" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.ppp_objects')}}
                        </router-link>
                        <!--                        <a class="nav-link effect-underline js-anchor-link" href="/#objectspart">{{$t('message.ppp_objects')}}</a>-->
                    </li>
                    <li class="nav-item">
                        <router-link to="/realized-objects" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.realized_objects')}}
                        </router-link>
                    </li>
                </ul>
                <ul class="navbar-nav navbar-mobile nav-desk">
                    <li class="nav-item">
                        <router-link to="/private-schools" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.private_schools')}}
                        </router-link></li>
                    <li class="nav-item">
                        <router-link to="/#faqpart" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.faq')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/contact-us" class="nav-link effect-underline js-anchor-link">
                            {{$t('message.contact_us')}}
                        </router-link>
                    </li>
                    <b-nav-item-dropdown right>
                        <template slot="button-content">
                            <div class="lang_icon"></div>
                            <!--                            <img src="/static/images/icons/language.svg" class="d-inline-block align-top" width="26" style="margin-top: -1px" alt="Kitten">-->
                            <b class="lang_suffix ">{{selectedLocale.suffix.toUpperCase()}}</b>
                        </template>
                        <b-dropdown-item v-for="language in languages" :key="language.name"
                                         @click="changeLanguage(language)">{{ language.name }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </ul>
            </div>
        </div>
        <div  :class="(!mobile_open) ? 'bsnav-mobile': 'bsnav-mobile in'">
            <div class="bsnav-mobile-overlay"></div>
            <div class="navbar">
                <ul class="hovertextnavbar-nav navbar-mobile nav-mob">
                    <li class="nav-item">
                        <router-link to="/about-part" class="nav-link"> {{$t('message.about_management')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/#objectspart" class="nav-link">{{$t('message.ppp_objects')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/realized-objects" class="nav-link"> {{$t('message.realized_objects')}}
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/private-schools" class="nav-link"> {{$t('message.private_schools')}}
                        </router-link>
                    </li>
                    <li class="nav-item"><router-link to="/#faqpart" class="nav-link">{{$t('message.faq')}}</router-link></li>
                    <li class="nav-item">
                        <router-link to="/contact-us" class="nav-link"> {{$t('message.contact_us')}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <router-view></router-view>
        <the-footer></the-footer>
    </div>
</template>

<script>
    // import TheNavbar from "./footer";
    import TheFooter from "./footer";
    import {mapGetters} from "vuex";

    export default {
        components: {
            TheFooter
        },
        data() {
            return {
                mobile_open: false
            }
        },
        computed: {
            ...mapGetters(["selectedLocale", "languages"])
        },
        mounted() {
            if (this.languages.length > 3) {
                this.languages.splice(0, 3)
            }
            this.$i18n.locale = this.selectedLocale.suffix.toLowerCase();
        },
        methods: {
            changeLanguage(language) {
                this.$i18n.locale = language.suffix.toLowerCase();
                this.$store.dispatch("changeLanguage", language);
            }
        }
    }
</script>
<style scoped>

    .lang_icon {
        width: 26px;
        background: url('/static/images/icons/language.svg') 100% 100% / cover no-repeat;
        height: 26px;
        display: inline-grid;
        position: inherit;
    }

    .sticked.in .lang_icon {
        width: 26px;
        background: url('/static/images/icons/language_color.svg') 100% 100% / cover no-repeat;
        height: 26px;
        display: inline-grid;
        position: inherit;
    }

    .lang_suffix {
        display: inline-flex !important;
        position: inherit !important;
        top: -6px !important;
        padding-left: 5px !important;
    }

    .lang_mob {
        display: none;
    }

</style>
<style>
    .sticked_navbar {
        transition: transform .4s .2s;
        transform: translate3d(0, 0, 0);
        box-shadow: 0 0 4px rgba(8, 123, 206, .14), 0 4px 8px rgba(8, 123, 206, .28);
        height: 70px;
        transition: 0.9s;
        background-image: linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%);
    }

    .sticked_navbar .nav-item {
        color: #087bce;
    }

    .sticked_navbar .lang_suffix {
        color: #087bce;
    }

    .sticked_navbar.sticked {
        position: fixed;
    }
</style>
